import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Modal from '../shared/Modal'
import { useImportSteps } from './hooks'
import {
  PreparationStep,
  ImportationStep,
  FinalisationStep,
  Stepper,
  ModalFooter
} from './components'

const CollectImportModal = ({ collectId, isOpen, onClose, onSuccess }) => {
  const {
    step,
    file,
    validationResult,
    validating,
    error,
    setFile,
    goBack,
    goNext,
    getParsedSections,
    reset
  } = useImportSteps(collectId)

  const handleClose = useCallback(() => {
    onClose()
    setTimeout(reset, 300)
  }, [onClose, reset])

  const handleImport = useCallback(() => {
    const sections = getParsedSections()
    if (sections) {
      setTimeout(reset, 300)
      if (onSuccess)
        onSuccess(sections)
    }
  }, [getParsedSections, reset, onSuccess])

  const renderStep = () => {
    switch (step) {
    case 1:
      return <PreparationStep collectId={collectId} />
    case 2:
      return (
        <ImportationStep
          collectId={collectId}
          error={error}
          file={file}
          validating={validating}
          validationResult={validationResult}
          onFileChange={setFile}
        />
      )
    case 3:
      return (
        <FinalisationStep
          fileName={file?.name || ''}
          questionsCount={validationResult?.questionsCount || 0}
          sectionsCount={validationResult?.sectionsCount || 0}
        />
      )
    default:
      return null
    }
  }

  const modalTitle = (
    <>
      <i className="fas fa-upload mr-2" />
      <span>Importer un questionnaire</span>
    </>
  )

  const canGoToStep3 = file && !validating && validationResult?.success === true

  return (
    <Modal
      footer={(
        <ModalFooter
          canGoNext={canGoToStep3}
          step={step}
          onBack={goBack}
          onClose={handleClose}
          onImport={handleImport}
          onNext={goNext}
        />
      )}
      headerClass="bg-success text-white"
      isOpen={isOpen}
      title={modalTitle}
      onClose={handleClose}
    >
      <Stepper currentStep={step} />
      {renderStep()}
    </Modal>
  )
}

CollectImportModal.propTypes = {
  collectId: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func
}

CollectImportModal.defaultProps = {
  onSuccess: null
}

export default CollectImportModal
